import Phaser from "phaser";

const STATES = {
    DEFAULT: "DEFAULT",
    SECOND: "SECOND"
}

export default class Button {
    constructor({
                    scene,
                    img,
                    imgPressed,
                    imgSecondState,
                    x,
                    y,
                    text,
                    style,
                    textColor = 0xdddddd,
                    textMove = - 10,
                    scaleX = 1,
                    scaleY = 1,
                    pointerOverColor
                }) {
        this.x = x;
        this.y = y;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        this.textMove = textMove;
        this.buttonGroup = scene.add.group();
        this.textColor = textColor;
        if(pointerOverColor){
            this.pointerOverColor = pointerOverColor;
        } else{
            this.pointerOverColor = this.textColor;
        }
        this.text = scene.add.text(0, 0, text, style);
        this.text.depth = 2;
        this.text.setOrigin(0.5,0.5);
        if(imgSecondState){
            this.imageSecondState = scene.add.image(0, 0, imgSecondState);
        }
        this.imagePressed = scene.add.image(0, 0, imgPressed);
        this.image = scene.add.image(0, 0, img);
        this.image.setInteractive();
        this.buttonGroup.add(this.text);
        if(this.imagePressed){
            this.buttonGroup.add(this.imagePressed);
        }
        if(this.imageSecondState){
            this.buttonGroup.add(this.imageSecondState);
        }
        this.buttonGroup.add(this.image);
        this.imagePressed.alpha = 0;
        Phaser.Actions.SetXY(this.buttonGroup.getChildren(), x, y, 0);
        this.text.setTint(this.textColor);

        this.toggleTimeout = 100;
        this.canPress = true;

        this.image.on("pointerover", () => {
            this.text.setTint(this.pointerOverColor);
        })
        this.image.on("pointerout", (...args) => {
            this.text.setTint(this.textColor);
            this.buttonReleased(...args);
        })

        this.image.on("pointerdown", (...args) => this.buttonPressed(...args))
        this.image.on("pointerup", (...args) => {
            this.buttonReleased(...args);
            this.onUp(...args);
        })
        this.image.on("pointerupoutside", (...args) => this.buttonReleased(...args))
        this.buttonGroup.children.entries.forEach(c => {
            c.setScale(scaleX, scaleY)
        })

        this.state = STATES.DEFAULT;
    }

    show(){
        this.buttonGroup.setVisible(true);
    }

    hide(){
        this.buttonGroup.setVisible(false);
    }

    buttonPressed(){
        if(!this.canPress) return;
        setTimeout(() => {this.canPress = true;}, this.toggleTimeout);
        this.canPress = false;
        this.pressed = true;
        if(this.imagePressed){
            this.image.alpha = 0.01;
            this.imagePressed.alpha = 1;
        }
        this.text.y = this.y - this.textMove;
        this.onDown();
    }
    buttonReleased() {
        if(!this.pressed) return;
        this.pressed = false;
        if(this.imagePressed){
            this.image.alpha = 1;
            this.imagePressed.alpha = 0;
        }
        if(this.imageSecondState){
            if(this.state === STATES.DEFAULT){
                this.state = STATES.SECOND;
                this.image.alpha = 0.01;
                this.imageSecondState.alpha = 1;
            } else{
                this.state = STATES.DEFAULT;
                this.image.alpha = 1;
                this.imageSecondState.alpha = 0;
            }
        }
        this.text.y = this.y + this.textMove;
        this.onClick(this.state);
    }
    onClick(){}
    onDown(){}
    onUp(){}
}